// newApplicantsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { CERTIFICATE_TYPE } from '../../data/NewApplicantsConstants';
import {
  fetchAppeals,
  fetchAtpUsers,
  getCpdSubmissionList,
  fetchATPActivities,
  getMemberShipList,
} from '../../api/tableServices';
import { ATP_PROFILE_STATUS_CONSTANT } from '../../data/AtpConstans';
import { CPD_SUBMISSION_STATUS_CONSTANT } from '../../data/CpdSubmissionConstants';
import { MEMBERSHIP_STATUS } from '../../data/MembershipConstants';
import { RENEWAL_STATUS } from '../../data/RenewalConstants';

// initial state
const initialState = {
  loading: false,
  error: null,
  data: {
    current_page: 1,
    page_limit: 10,
    total_pages: 1,
  },
  cpdCertificateType: CERTIFICATE_TYPE.ALL_AVAILABLE,
  certificateType: CERTIFICATE_TYPE.ALL,
  atpStatus: ATP_PROFILE_STATUS_CONSTANT.PENDING,
  cpdSubmissionStatus: CPD_SUBMISSION_STATUS_CONSTANT.ALL,
  search: '',
  atpActivitiesStatus: CPD_SUBMISSION_STATUS_CONSTANT.PENDING,
  memberShipStatus: MEMBERSHIP_STATUS.ALL_AVAILABLE,
  renewalStatus: RENEWAL_STATUS.PENDING,
  full_name: '',
  organization: '',
  identity_number: '',
  typeOfCpd: '',
  submission_date: '',
};

// slice
const tablesSlice = createSlice({
  name: 'newApplicants',
  initialState,
  reducers: {
    handleLoading: (state, action) => {
      state.loading = action.payload;
    },
    handleCertificateType: (state, action) => {
      state.certificateType = action.payload;
    },
    handleCurrentPage: (state, action) => {
      state.data.current_page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    handleATPStatus: (state, action) => {
      state.atpStatus = action.payload;
    },
    handleCPDStatus: (state, action) => {
      state.cpdSubmissionStatus = action.payload;
    },
    handleCPDCertificateStatus: (state, action) => {
      state.cpdCertificateType = action.payload;
    },
    handleMemberShipStatus: (state, action) => {
      state.memberShipStatus = action.payload;
    },
    resetData: (state, action) => {
      state.data = {
        current_page: 1,
        page_limit: 10,
        total_pages: 1,
      };
      state.search = '';
    },
    handleATPActivitiesStatus: (state, action) => {
      state.atpActivitiesStatus = action.payload;
    },
    handleMemberShipStatus: (state, action) => {
      state.memberShipStatus = action.payload;
    },
    handleRenewalStatus: (state, action) => {
      state.renewalStatus = action.payload;
    },
    handleCpdFullName: (state, action) => {
      state.full_name = action.payload;
    },
    handleCpdOrganization: (state, action) => {
      state.organization = action.payload;
    },
    handleCpdIdentityNumber: (state, action) => {
      state.identity_number = action.payload;
    },
    handleTypeOfCpd: (state, action) => {
      state.typeOfCpd = action.payload;
    },
    handleCpdSubmissionDate: (state, action) => {
      state.submission_date = action.payload;
    },
    logoutTable: (state, action) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppeals.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (action.payload.total_pages === 0) {
          state.data.total_pages = 1;
        } else {
          state.data.total_pages = action.payload.total_pages;
        }
      })
      .addCase(fetchAppeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAtpUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAtpUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (action.payload.total_pages === 0) {
          state.data.total_pages = 1;
        } else {
          state.data.total_pages = action.payload.total_pages;
        }
      })
      .addCase(fetchAtpUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCpdSubmissionList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCpdSubmissionList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = { ...action.payload };
        if (action.payload.total_pages === 0) {
          state.data.total_pages = 1;
        } else {
          state.data.total_pages = action.payload.total_pages;
        }
      })
      .addCase(getCpdSubmissionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchATPActivities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchATPActivities.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = { ...action.payload };
      })
      .addCase(fetchATPActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMemberShipList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMemberShipList.fulfilled, (state, action) => {
        state.loading = false;
        // state.profileData = { ...action.payload };
        state.data = { ...action.payload };
      })
      .addCase(getMemberShipList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the actions and reducer
export const {
  handleLoading,
  handleSelfCheckTableDetails,
  handleCertificateType,
  handleCurrentPage,
  setSearch,
  resetData,
  handleATPStatus,
  handleCPDStatus,
  handleCPDCertificateStatus,
  handleATPActivitiesStatus,
  handleMemberShipStatus,
  handleRenewalStatus,
  logoutTable,
  handleCpdFullName,
  handleCpdOrganization,
  handleCpdIdentityNumber,
  handleTypeOfCpd,
  handleCpdSubmissionDate
} = tablesSlice.actions;
export default tablesSlice.reducer;
